import {
  ADD_TO_COMPARE,
  CART_UPDATED,
  REMOVE_FROM_COMPARE,
  CLEAR_COMPARE,
  FETCH_COMPARE,
  RECEIVE_COMPARE,
  FAILED_COMPARE,
  RECEIVE_COMPARE_COUNT
} from "../constants/ActionTypes";
import toast from "../utils/toast";

// Normalize API compare item to match the shape components expect
function normalizeCompareItem(apiItem) {
  const variant = {
    id: apiItem.variant_id,
    offerprice: apiItem.offerprice,
    price: apiItem.price,
    image: apiItem.image,
    stock: apiItem.stock,
    metal_weight: apiItem.metal_weight,
    metal_purity: apiItem.metal_purity,
    color: apiItem.color ,
    metal_type: apiItem.metal_type
  };
  return {
    id: apiItem.product_id,
    compare_id: apiItem.compare_id,
    name: apiItem.product_name,
    product_name: apiItem.product_name,
    sku: apiItem.product_sku,
    category: apiItem.category_id,
    product_type: apiItem.product_type,
    value: apiItem.value,
    metal_type: apiItem.metal_type,
    active: apiItem.active !== "false",
    variant: variant,
    selectedVariant: variant,
    variants: [variant],
  };
}

export default function compareReducer(
  state = {
    items: [],
    loading: false,
    count: 0
  },
  action
) {
  switch (action.type) {
    case CLEAR_COMPARE:
      return { items: [], loading: false, count: 0 };
    case FETCH_COMPARE:
      return { ...state, loading: true };
    case RECEIVE_COMPARE: {
      const rawItems = action.payload && action.payload.result;
      const items = Array.isArray(rawItems)
        ? rawItems.map(normalizeCompareItem)
        : [];
      return {
        ...state,
        loading: false,
        items: items,
        count: items.length
      };
    }
    case FAILED_COMPARE:
      return { ...state, loading: false };
    case RECEIVE_COMPARE_COUNT: {
      const result = action.payload && action.payload.result;
      const countVal = result && result.count !== undefined
        ? result.count
        : undefined;
      return {
        ...state,
        count: countVal !== undefined ? countVal : state.count
      };
    }
    case ADD_TO_COMPARE:
      const productId = action.product.id;
      const variantId = action.variant.id;
      if (state.items.findIndex(product => product.variant && product.variant.id === variantId) !== -1) {
        const items = state.items.reduce((cartAcc, product) => {
          cartAcc.push({
            ...product,
          });
          return cartAcc;
        }, []);
        toast.warn("Item already Added", { toastId: "compare-already-added" });
        return { ...state, items };
      } else {
        toast.success("Item Added to Compare list", { toastId: "add-to-compare" });
      }
      return {
        ...state,
        items: [...state.items, { ...action.product, variant: action.variant }],
        count: state.count + 1
      };

    case CART_UPDATED:
      return {
        ...state,
        items: state.items.map(oldItem => {
          const match = action.payload.find(newItem => oldItem.id === newItem.id);
          if (!match) return oldItem;
          return {
            ...oldItem,
            active: match.deleted ? false : true,
            variant: oldItem.variant
              ? { ...oldItem.variant, offerprice: match.variant.offerprice }
              : oldItem.variant,
            selectedVariant: oldItem.selectedVariant
              ? { ...oldItem.selectedVariant, offerprice: match.variant.offerprice }
              : oldItem.selectedVariant,
          };
        })
      };

    case REMOVE_FROM_COMPARE: {
      const removeId = action.product_id && action.product_id.variant
        ? action.product_id.variant.id
        : action.product_id && action.product_id.id
        ? action.product_id.id
        : action.product_id;
      return {
        ...state,
        items: state.items.filter(item =>
          item.variant ? String(item.variant.id) !== String(removeId) : item !== action.product_id
        ),
        count: Math.max(0, state.count - 1)
      };
    }
    default:
  }
  return state;
}
